import { render, staticRenderFns } from "./new reviews.vue?vue&type=template&id=af41a2d4"
import script from "./new reviews.vue?vue&type=script&lang=js"
export * from "./new reviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports